import React, { useState } from "react";
import { useSelector } from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UserPDFModal from "./UserPDFModal";
const LogoSlider = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [company, setCompany] = useState(null);
  const partners = useSelector((state) =>
    state.partners?.partners
      .filter((member) => member.approvalStatus === "Đã duyệt")
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      ?.slice(0, 7)
  );
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1000,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <div className="container mx-auto ">
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body p-0">
          {/* <Slider {...settings} className="partner-slider"> */}
          {partners.map((partner) => (
            <div
              key={partner.id}
              className=""
              onClick={() => {
                setIsOpenModal(true);
                setCompany(partner);
              }}
            >
              <div className="flex shadow-md rounded-lg p-2 gap-2 bg-base-100 hover:bg-gray-200 items-center">
                <div className="w-1/3 ">
                  {partner?.userAvatar ? (
                    <img
                      src={partner.userAvatar}
                      alt={partner.companyName}
                      className="rounded-md object-contain w-14 h-14"
                    />
                  ) : (
                    <img
                      src={`https://ui-avatars.com/api/?name=${partner.companyName}&size=200&background=random&color=fff&bold=true`}
                      alt="Profile"
                      className="rounded-md object-contain w-14 h-14"
                      loading="eager"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `https://ui-avatars.com/api/?name=${partner.companyName}&size=200&background=random&color=fff&bold=true`;
                      }}
                    />
                  )}
                </div>
                <div className="w-2/3 flex items-center">
                  <h2 className="text-sm font-semibold mb-1">
                    {partner.companyName}
                  </h2>
                </div>
              </div>
            </div>
          ))}
          {/* </Slider> */}
        </div>
      </div>

      <UserPDFModal
        isOpen={isOpenModal}
        company={company}
        onClose={handleCloseModal}
      />

      <style jsx>{`
        .vertical-partner-slider .slick-prev,
        .vertical-partner-slider .slick-next {
          left: 50%;
          transform: translateX(-50%);
        }

        .vertical-partner-slider .slick-prev {
          top: -20px;
        }

        .vertical-partner-slider .slick-next {
          top: auto;
          bottom: -20px;
        }

        .vertical-partner-slider .slick-prev:before,
        .vertical-partner-slider .slick-next:before {
          color: #666;
        }

        .vertical-partner-slider .slick-dots {
          right: -20px;
          left: auto;
          top: 50%;
          transform: translateY(-50%);
          width: auto;
          height: auto;
          display: flex !important;
          flex-direction: column;
        }

        .vertical-partner-slider .slick-dots li {
          margin: 5px 0;
        }

        .vertical-partner-slider .slick-track {
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </div>
  );
};

export default LogoSlider;
